import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AggregatedResidents } from '../model/aggregated-residents';
import { ExtractedSmKeywords } from '../model/extracted-sm-keywords';
import { UrlConfig } from '../model/urlconfig';

@Injectable({
  providedIn: 'root',
})
export class ServerSideProcessorService implements UrlConfig{
  constructor(private httpClient: HttpClient) { }
 
  private url;
  updateEntitiesUrl(newBaseUrl: string): void {
    this.url = newBaseUrl;
  }

  getAggregatedResidents(coordinates: string) {
     const aggregatedUrl = this.url + '/residents/aggregated';

    return this.httpClient.get<AggregatedResidents>(aggregatedUrl, {
      params: {
        coordinates,
      },
    });
  }

  /**
   * localhost:3008/smanaylzer/wordcloud?dateFrom=2021-01-14T17:36:32.000Z&dateTo=2021-09-17T17:36:32.000Z&searchIds=277,278&network=twitter,youtube
   *
   * @param dateFrom
   * @param dateTo
   * @param searchIds
   * @param networks
   * @param withImage
   */
  getWordCloudData(dateFrom: string, dateTo: string, searchIds?: string[], networks?: string[], withImage?: boolean) {
    const wordCloudUrl = this.url + '/smanaylzer/wordcloud';

    const params: WordCloudParams = {
      dateFrom,
      dateTo,
    };

    if (networks && networks.length > 0) {
      params.network = networks.join(',');
    }

    if (params.withImage) {
      params.withImage = withImage.toString();
    }

    if (searchIds && searchIds.length > 0) {
      params.searchIds = searchIds.join(',');
    }

    let httpParams = new HttpParams();
    Object.keys(params).forEach((p) => (httpParams = httpParams.set(p.toString(), params[p].toString())));

    return this.httpClient.get<ExtractedSmKeywords>(wordCloudUrl, {
      params: httpParams,
    });
  }
}

interface WordCloudParams {
  dateFrom: string;
  dateTo: string;
  network?: string;
  searchIds?: string;
  withImage?: string;
}
